import { render, staticRenderFns } from "./MoreCard.vue?vue&type=template&id=a5b645cc&scoped=true"
import script from "./MoreCard.vue?vue&type=script&lang=js"
export * from "./MoreCard.vue?vue&type=script&lang=js"
import style0 from "./MoreCard.vue?vue&type=style&index=0&id=a5b645cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b645cc",
  null
  
)

export default component.exports